import { render, staticRenderFns } from "./ProfileCouponsActivateForm.vue?vue&type=template&id=53a2fb11&scoped=true&"
import script from "./ProfileCouponsActivateForm.vue?vue&type=script&lang=ts&"
export * from "./ProfileCouponsActivateForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileCouponsActivateForm.vue?vue&type=style&index=0&id=53a2fb11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a2fb11",
  null
  
)

export default component.exports